/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Compliance_Toggle_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle {title} pattern" |
*
* @param {Compliance_Toggle_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_toggle_label = /** @type {((inputs: Compliance_Toggle_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Toggle_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.title} Muster umschalten`)
	return /** @type {LocalizedString} */ (`Toggle ${i?.title} pattern`)
});